import axios from 'axios';
import config from '@/config'; // Assuming you have a config file as discussed earlier

const api = axios.create({
    baseURL: config.services.host, // e.g., 'https://api.mypurecloud.com'
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true, // If needed
});

export default api;